
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DELETE } from 'utils/http';
import BACKEND_URL from 'constants/backendUrl';
import { toast } from 'react-toastify';
import { useModalStore } from 'stores/modal';
import { ModalType } from 'core/useCases/modal/types';
import Delete from 'images/icons/Delete.svg?react';
import { useHistory, useLocation } from 'react-router-dom';
import { useInvalidateEvents } from 'core/api/events';

const deleteEventRequest = async (id: string): Promise<void> => {
    await DELETE(`${BACKEND_URL}/api/event/${id}`);
};

type DeleteEventButtonProps = {
    eventId: string;
};

const DeleteEventButton: FC<DeleteEventButtonProps> = ({ eventId }) => {
    const { t } = useTranslation();
    const invalidateEvents = useInvalidateEvents();
    const history = useHistory();
    const { pathname } = useLocation();
    const isContactPage = pathname.split('/')[1] === 'contact';
    const openModal = useModalStore((s) => s.openModal);

    const openConfirmationModal = () => {
        openModal({
            confirmAction: async () => {
                try {
                    await deleteEventRequest(eventId);
                    invalidateEvents();
                    toast.success(t('event.remove.success'));
                    // No redirection if on contact page
                    if (!isContactPage) {
                        history.push('/activities');
                    }
                } catch (error) {
                    toast.error(t('event.remove.error'));
                }
            },
            title: t('event.remove.ask-to-delete'),
            type: ModalType.Confirmation,
        });
    };

    return (
        <button onClick={openConfirmationModal} title={t('event.remove.label')} type="button">
            <Delete />
        </button>
    );
};

export default DeleteEventButton;
